function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.54545 0H49.9091C52.9717 0 55.4545 2.48278 55.4545 5.54545L55.4545 8.31818C58.5172 8.31818 61 10.801 61 13.8636V19.4091C61 22.4717 58.5172 24.9545 55.4545 24.9545L55.4545 27.7273C55.4545 30.7899 52.9717 33.2727 49.9091 33.2727H5.54545C2.48278 33.2727 0 30.7899 0 27.7273V5.54545C0 2.48278 2.48278 0 5.54545 0ZM5.54543 5.54544V27.7272H49.909V5.54544H5.54543Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 8H16V25H9V8Z",
  fill: "#FF75AA"
});

var SvgBattery04 = function SvgBattery04(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 34,
    viewBox: "0 0 60 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBattery04, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/battery_04.31d75e12.svg";
export { ForwardRef as ReactComponent };